import locale from 'date-fns/locale/nb';

export const dateFnConfig = { locale };
